import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiRoutes, refreshTokenExceptions, tokenExceptions } from '../constans/api';
import { genToastBody, getErrorDesc } from '../helpers/helpers';
import i18n from '../i18n';
import store from '../redux/store';
import { refreshToken } from '../services/auth';

const axiosInstance = axios.create({
  baseURL: '/api',
});
let refreshIsInProgress = false;
let requestQue: ((token: string) => void)[] = [];

function onRefreshed(authorizationToken: string) {
  requestQue.map(cb => cb(authorizationToken));
}

function subscribeTokenRefresh(cb: (token: string) => void) {
  requestQue.push(cb);
}
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config.headers) {
      const { url } = config;
      config.headers['Accept-Language'] = i18n.language;
      if (url && !tokenExceptions.some(route => route === url)) {
        const { userData } = store.getState().auth;
        const token = userData?.access;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      }
      return config;
    }
    return config;
  },
  async err => await Promise.reject(err)
);

const interceptorOnRejected = async (config: AxiosRequestConfig, response: AxiosResponse) => {
  const { url, method } = config;
  const safeUrl = url || '';
  const { status, data } = response;
  const newDetails = getErrorDesc(data);
  const { title, description } = newDetails;
  const originalRequest = config;
  const urlArr = safeUrl.split('/');
  if (refreshTokenExceptions.some(route => route === safeUrl)) {
    return Promise.reject(response);
  }
  if (safeUrl === ApiRoutes.refreshToken) {
    await genToastBody(title, description);
    return Promise.reject(response);
  }
  if (status === 401) {
    const retryOrigReq = new Promise(resolve => {
      subscribeTokenRefresh((token: string) => {
        const headers = originalRequest.headers ?? {};
        originalRequest.headers = headers;
        (headers as Record<string, string>).Authorization = `Bearer ${token}`;
        resolve(axios(originalRequest));
      });
    });
    if (!refreshIsInProgress) {
      refreshIsInProgress = true;
      const refreshedAccessToken = await refreshToken();
      refreshIsInProgress = false;
      onRefreshed(refreshedAccessToken);
      requestQue = [];
    }
    return retryOrigReq;
  }
  if (
    (method === 'post' && safeUrl === ApiRoutes.surveyList) ||
    (method === 'post' && urlArr.includes('participants')) ||
    (method === 'post' && urlArr.includes('reporting-groups')) ||
    (method === 'patch' && urlArr.includes('participants'))
  ) {
    return Promise.reject(response);
  }
  if (
    ((status === 409 || status === 400) &&
      (method === 'post' || method === 'patch') &&
      safeUrl.includes(ApiRoutes.participantsTeams)) ||
    safeUrl.includes(ApiRoutes.reportingGroups)
  ) {
    return Promise.reject(response);
  }
  await genToastBody(title, description);
  return Promise.reject(response);
};

axiosInstance.interceptors.response.use(
  response => response,
  async ({ response, config }) => await interceptorOnRejected(config, response)
);

export default axiosInstance;
